export const formatTestID = (...strings: (string | null | undefined)[]) =>
  strings.filter((val) => val).join('-')
